/** S3 base URL before the CDN image folder. */
export const IMAGE_CDN_BASE_URL =
  'https://ghrus.s3.ap-south-1.amazonaws.com/ghru/images-new/';

/** Build a CDN URL from an image object key relative to images-new/. */
export function imageCdnUrl(path: string): string {
  return `${IMAGE_CDN_BASE_URL}${path.replace(/^\/+/, '')}`;
}
